<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ title() }}
    </ion-title>
  </ion-toolbar>
</ion-header>
